module.exports = __webpack_public_path__ + "img/weber_metallbearbeitung_kugelpoliert_01.381edd42.jpg";